<div class="content-container">
  <img ngSrc="assets/images/disconnection.svg" width="250" height="183" alt="error" priority />
  <h2>Onze excuses, de pagina die u zoekt is nu niet bereikbaar</h2>
  <div class="content">
    <p>
      Dit heeft waarschijnlijk te maken met interne serverproblemen. <br />
      Wij zullen het probleem zo snel mogelijk verhelpen.
    </p>

    <p>Probeer het later nog eens of ga naar <a href="https://www.knab.nl/contact" target="_blank" rel="noopener noreferrer">knab.nl/contact</a>.</p>
    @if (this.publicId) {
      <p>Betaalverzoek ID: {{ this.publicId }}</p>
    }
    @if (this.traceId) {
      <p>Trace ID: {{ this.traceId }}</p>
    }
  </div>
</div>
